
import React from "react";
import { LucideIcon } from "lucide-react";
import { SectionTitle } from "@/components/SectionTitle";
import { ServiceFeatureCard } from "@/components/ServiceFeatureCard";

interface ServiceFeature {
  icon: LucideIcon;
  title: string;
  description: string;
}

interface ServiceFeaturesSectionProps {
  title: string;
  subtitle: string;
  features: ServiceFeature[];
}

export const ServiceFeaturesSection: React.FC<ServiceFeaturesSectionProps> = ({
  title,
  subtitle,
  features,
}) => {
  return (
    <section className="py-16">
      <div className="container-custom">
        <SectionTitle
          title={title}
          subtitle={subtitle}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
